import useApi from "@/hooks/useApi";
import React from "react";
import { AutoResponse } from "../types";
import CreateModal from "./CreateModal";
import EditModal from "./EditModal";

export default function AutoResponseSettings() {
  const [showCreateModal, setShowCreateModal] = React.useState(false);
  const [editId, setEditId] = React.useState<number | undefined>();
  const [autoResponses, setAutoResponses] = React.useState<AutoResponse[]>([]);
  const api = useApi();

  const fetchAutoResponses = React.useCallback(async () => {
    const response = await api.messaging.get("AutoResponses/List");
    setAutoResponses(await response.json());
  }, [api.messaging]);

  React.useEffect(() => {
    fetchAutoResponses();
  }, [fetchAutoResponses]);

  async function deleteObject(id: number) {
    if (confirm("Are you sure you want to delete this?")) {
      await api.messaging.delete(`AutoResponses/${id}`);
      await fetchAutoResponses();
    }
  }

  return (
    <>
      <div className="px-6 pt-5 pb-4 flex items-center gap-3 border-b border-slate-200 bg-white">
        <div className="flex-1 min-w-0">
          <h1 className="text-lg font-semibold text-slate-900 tracking-tight">Auto Responses</h1>
          <p className="text-xs text-slate-400 mt-0.5">Automated replies triggered by keywords or conditions</p>
        </div>
        <button
          className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md bg-[var(--color-primary)] text-white text-sm font-medium hover:opacity-90 transition-opacity shadow-sm"
          onClick={() => setShowCreateModal(true)}
        >
          + New Auto Response
        </button>
      </div>
      <div className="m-4">
        <table className="w-full">
          <thead>
            <tr>
              <th className="px-6 py-3 text-left text-[11px] font-semibold text-slate-400 uppercase tracking-wider">Title</th>
              <th className="px-6 py-3 text-left text-[11px] font-semibold text-slate-400 uppercase tracking-wider">Days of Week</th>
              <th className="px-6 py-3 text-left text-[11px] font-semibold text-slate-400 uppercase tracking-wider">All Day</th>
              <th className="px-6 py-3 text-left text-[11px] font-semibold text-slate-400 uppercase tracking-wider" style={{ width: 1 }}></th>
            </tr>
          </thead>
          <tbody>
            {autoResponses.map((autoResponse) => (
              <tr key={autoResponse.id} className="border-b border-slate-100 hover:bg-slate-50/70 transition-colors">
                <td className="px-6 py-3 text-sm text-slate-600">{autoResponse.title}</td>
                <td className="px-6 py-3 text-sm text-slate-600">{autoResponse.daysOfWeek}</td>
                <td className="px-6 py-3 text-sm text-slate-600">
                  {autoResponse.isAllDay.toString()}
                </td>
                <td className="px-6 py-3 text-sm text-slate-600 whitespace-nowrap">
                  <button
                    className="text-[var(--color-primary)] hover:underline text-sm"
                    onClick={() => setEditId(autoResponse.id)}
                  >
                    Edit
                  </button>
                  <span className="mx-2 text-slate-300">&bull;</span>
                  <button
                    className="text-red-500 hover:underline text-sm"
                    onClick={() => deleteObject(autoResponse.id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {showCreateModal && (
        <CreateModal
          show={showCreateModal}
          onClose={() => setShowCreateModal(false)}
          onCreate={() => {
            fetchAutoResponses();
            setShowCreateModal(false);
          }}
        />
      )}
      {editId && (
        <EditModal
          autoResponseId={editId}
          onClose={() => setEditId(undefined)}
          onUpdate={() => {
            setEditId(undefined);
            fetchAutoResponses();
          }}
        />
      )}
    </>
  );

  // return (
  //   <>
  //     <div>
  //       <div>
  //         <button
  //           className="btn-green"
  //           onClick={() => setShowCreateModal(true)}
  //         >
  //           New Auto Response
  //         </button>
  //       </div>
  //       <table>
  //         <thead>
  //           <tr>
  //             <th>Title</th>
  //             <th>Days of Week</th>
  //             <th>All Day</th>
  //             <th></th>
  //           </tr>
  //         </thead>
  //         <tbody>
  //           {autoResponses.map((autoResponse) => (
  //             <tr key={autoResponse.id}>
  //               <td>{autoResponse.title}</td>
  //               <td>{autoResponse.daysOfWeek}</td>
  //               <td>{autoResponse.isAllDay.toString()}</td>
  //               <th>
  //                 <button onClick={() => setEditId(autoResponse.id)}>
  //                   Edit
  //                 </button>
  //                 <button onClick={() => deleteObject(autoResponse.id)}>
  //                   Delete
  //                 </button>
  //               </th>
  //             </tr>
  //           ))}
  //         </tbody>
  //       </table>
  //     </div>
  //     {showCreateModal && (
  //       <CreateModal
  //         show={showCreateModal}
  //         onClose={() => setShowCreateModal(false)}
  //         onCreate={() => {
  //           fetchAutoResponses();
  //           setShowCreateModal(false);
  //         }}
  //       />
  //     )}
  //     {editId && (
  //       <EditModal
  //         autoResponseId={editId}
  //         onClose={() => setEditId("")}
  //         onUpdate={() => {
  //           setEditId("");
  //           fetchAutoResponses();
  //         }}
  //       />
  //     )}
  //   </>
  // );
}

const thClassName = "border p-2 text-left";
const tdClassName = "border p-2";
